import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';
import { I18nText } from '@welldev-group/react-comp-lib';
import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';

import TransactionPdfDocument from '../PdfDocuments/TransactionPdfDocument';
import PdfStyles from '../PdfDocuments/PdfStyles';

const TransactionPDF = ({ transactionId }) => {
  const [pdf, setPdf] = useState(null);

  const styles = StyleSheet.create(PdfStyles);

  const makePdf = data => {
    const { pdfDetails } = data;
    setPdf(
      <PDFDownloadLink
        document={<TransactionPdfDocument pdfDetails={pdfDetails} />}
        fileName={`${pdfDetails.title}.pdf`}
      >
        <span style={styles.linkContent}>
          <I18nText id="billing.transactions.list.label.download_pdf" />
        </span>
      </PDFDownloadLink>,
    );
  };

  const fetchPdfDetails = async id => {
    const { data } = await httpClient.get(routes.billing.transactions.pdf_details({ id }));
    makePdf(data);
  };

  useEffect(() => {
    fetchPdfDetails(transactionId);
  }, [transactionId]);

  return pdf;
};

TransactionPDF.propTypes = {
  transactionId: PropTypes.number.isRequired,
};

export default TransactionPDF;
